// React
import { useState } from "react";

// UI
import { Autocomplete, Typography, Box, Tooltip } from "@mui/material";
import ColoredTextField from "./ColoredTextField";
import CircularProgress from "@mui/material/CircularProgress";

const AutoCompleteICAT = (props) => {
  // Required
  const {
    row,
    onChange,
    value,
    onInputChange,
    options,
    isLoading,
    name,
    required=false,
  } = props;
  // Optional
  const { label, error, helperText, onClose, errorMessage="" } = props;

  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event, newValue, reason) => {
    setInputValue(newValue);    
    onInputChange(newValue, name, reason, row);
  };

  return (
    <>
    <Tooltip title={value ? value.label : ""}>
      <Autocomplete
        fullWidth
        onClose={onClose}
        autoHighlight
        id="AutoComplete ICAT"
        options={!isLoading ? options : []}
        disabled={props?.disabled}
        loading={isLoading}
        onChange={onChange}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        filterOptions={(options) => options}
        loadingText={
          <Box display={"flex"} sx={{ mx: "auto" }}>
            <CircularProgress color="inherit" size={80} />
          </Box>
        }
        value={value === "" ? null : value}
        getOptionLabel={(option) => {
          return option.label || "";
        }}
        isOptionEqualToValue={(option, value) => {
          return JSON.stringify(option) === JSON.stringify(value);
        }}
        renderOption={(props, option) => {
            const { key, ...restProps } = props;
            return (
                <li key={key + option?.id + option?.label} {...restProps}>
                    {option.label}
                </li>
            );
        }}
        noOptionsText={
          inputValue?.trim().length > 2
            ? "No Result"
            : "Enter at least 3 characters to search"
        }
        renderInput={(params) => (
          <ColoredTextField
            error={error ? true : false}
            focused
            required={required}
            {...params}
            label={label}
          />
        )}
      />
      </Tooltip>
      <Typography variant="caption" color={error && "secondary"}>
        {errorMessage || helperText}
      </Typography>
    </>
  );
};

export default AutoCompleteICAT;
